import { render, staticRenderFns } from "./el-tab-pane.vue?vue&type=template&id=54aea782&scoped=true"
import script from "./el-tab-pane.vue?vue&type=script&lang=js"
export * from "./el-tab-pane.vue?vue&type=script&lang=js"
import style0 from "./el-tab-pane.vue?vue&type=style&index=0&id=54aea782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aea782",
  null
  
)

export default component.exports